import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { useController, useFormContext } from "react-hook-form";
export function Field(param) {
    let { children , name  } = param;
    const { control  } = useFormContext();
    const field = useController({
        name,
        control
    });
    return /*#__PURE__*/ _jsx(FieldContext.Provider, {
        value: field,
        children: children
    });
}
export const FieldContext = /*#__PURE__*/ React.createContext(null);
export const useFieldContext = ()=>{
    const context = useContext(FieldContext);
    if (!context) throw new Error("You tried to use a field without using <FieldContext />");
    return context;
};
